import React from 'react'

import { Button } from '@frame/ui-primitives/button'
import { P } from '@frame/ui-primitives/p'

import { useVerifyTask } from '@frame/components/screens/tasks/hooks/useVerifyTask'
import { AlertDuotone } from '@frame/images/icons/alert-duotone'
import { ArrowRight } from '@frame/images/icons/arrow-right'
import { DirectTask } from '@frame/lib/api/tasks/types'

type Props = {
  bankTask: DirectTask
}

export function BankRedirectMessage({ bankTask }: Props) {
  const { handleConnectBank } = useVerifyTask()

  return (
    <div className="flex items-center justify-center gap-2 self-stretch rounded-md bg-electric-200 px-3 py-2">
      <div className="flex flex-col gap-2 self-stretch">
        <div className="flex items-center gap-2 self-stretch">
          <AlertDuotone className="h-4 w-4" />
          <P className="self-stretch text-xs font-medium leading-[1.225rem]">Pro tip</P>
        </div>
        <P>Consider connecting your bank account instead!</P>
      </div>
      <Button
        className="flex h-6 w-6 flex-shrink-0 items-center justify-center rounded-full p-[0.125rem]"
        onClick={() => handleConnectBank(bankTask)}
      >
        <ArrowRight className="h-5 w-5 p-[0.13125rem]" />
      </Button>
    </div>
  )
}
